module.exports = __webpack_public_path__ + "img/ergo-essential2.5efcc503.png";